import judgeTokenExp from '@/util/judgeTokenExp'
import { AddPurchase } from '@/networks/api' //, AddPurchase
import types from './types'
import { addPurchaseParams } from '@/defines'

export default {
  state() {
    return {
      courseDetail: null,
      addPurchaseCourseList: [],
      addPurchaseSift: null,
      addPurchaseAllSift: null,
      filterName: null,
      addPurchaseBread: null,
      page: 1,
      noMoreData: false,
      checkCourseResult: null,
      addpurchaseInfos: null,
      incPurchase: null
    }
  },
  mutations: {
    [types.SET_COURSE_DETAIL](state, payload) {
      state.courseDetail = payload
    },
    [types.SET_ADDPURCHASE_INFOS](state, payload) {
      state.addpurchaseInfos = payload
    },
    [types.SET_ADDPURCHASE_COURSE_LIST](state, payload) {
      state.addPurchaseCourseList = payload
    },
    [types.SET_ADDPURCHASE_SIFT](state, payload) {
      // 展现的筛选项
      state.addPurchaseSift = payload
    },
    [types.SET_ADDPURCHASE_ALL_SIFT](state, payload) {
      // 所以筛选项
      state.addPurchaseAllSift = payload
    },
    [types.SET_FILTERNAME](state, payload) {
      // 筛选列表标题Mapping
      state.filterName = payload
    },
    [types.SET_ADDPURCHASE_BREAD](state, payload) {
      // 筛选列表标题Mapping
      state.addPurchaseBread = payload
    },
    [types.SET_PAGE](state, payload) {
      state.page = payload
    },
    [types.SET_COURSELIST](state, payload) {
      state.addPurchaseCourseList = payload
    },
    [types.ADD_COURSE_LIST](state, payload) {
      state.addPurchaseCourseList = state.addPurchaseCourseList.concat(payload)
    },
    [types.SET_NOMOREDATE](state, payload) {
      state.noMoreData = payload
    },
    [types.SET_ADDPURCHASE_CHECK_COURSE](state, payload) {
      state.checkCourseResult = payload
    }
  },
  actions: {
    async [types.GET_COURSE_DETAIL]({ commit, rootState }, { route }) {
      try {
        const {
          params: { courseId, classId }
        } = route
        const { batchId } = route.query
        const { data } = await AddPurchase.getCourseDetail(
          { courseId, classId },
          {
            rootState,
            cookies: rootState.cookies,
            params: {
              xeswx_sourceid: route.query.xeswx_sourceid,
              xeswx_sourceurl: 'https://online.xueersi.com' + route.fullPath,
              batchId
            }
          }
        )
        commit(types.SET_COURSE_DETAIL, data.data)
      } catch (e) {
        commit(types.SET_COURSE_DETAIL, null)
        // commit(types.SET_INT_PURCHASE, null)
        const response = e.response
        const status = response && response.status
        if (status === 404) return
        console.log('APIERROR==GET_COURSE_DETAIL===', e)
      }
    },
    async [types.GET_ADDPURCHASE_SIFT](
      { dispatch, state, commit, rootState },
      { route }
    ) {
      // 加价购搜索条件
      try {
        await judgeTokenExp({ dispatch, rootState })
        const { query } = route
        const newQuery = {}
        for (let key in query) {
          if (query[key] && addPurchaseParams[key]) {
            newQuery[addPurchaseParams[key]] = query[key]
          }
        }
        const {
          data: { result }
        } = await AddPurchase.getSearchSift({ rootState, params: { ...newQuery } })
        // 过滤筛选项
        const { namesMapping, list } = result.data
        const newObj = Object.create(null)
        // 重置面包屑和筛选项
        for (let key in list) {
          const arr = list[key]
          if (arr && arr.length > 0) {
            const hitItem = arr.filter(item => item.checked)
            if (hitItem.length > 0) {
              newObj[key] = hitItem[0]
              delete list[key] // 删选隐藏项
            }
          }
        }
        commit(types.SET_ADDPURCHASE_BREAD, newObj)
        commit(types.SET_ADDPURCHASE_SIFT, list)
        commit(types.SET_FILTERNAME, namesMapping)
        commit(types.SET_ADDPURCHASE_ALL_SIFT, result.data.list)
      } catch (e) {
        const response = e.response
        const status = response && response.status
        if (status === 401) {
          await dispatch('GET_TOKEN')
          dispatch(types.GET_ADDPURCHASE_SIFT)
          return
        }
        const { flag = 1 } = route.query
        if (Number(flag) === 1) {
          commit(types.RESET_BREADFILITEM)
        }
        commit(types.SET_ADDPURCHASE_SEARCH_SIFT, null)
        commit(types.SET_FILTERNAME, null)
        if (status === 404) return
        console.log('APIERROR==GET_ADDPURCHASE_SIFT===', e)
      }
    },
    async [types.GET_ADDPURCHASE_COURSE_LIST](
      { commit, dispatch, state, rootState },
      { route, isLoadMore }
    ) {
      if (!isLoadMore) {
        // page页数重置为1 列表重置为[]
        commit(types.SET_PAGE, 1)
        commit(types.SET_NOMOREDATE, false)
        commit(types.SET_COURSELIST, [])
      }
      if (state.noMoreData) return
      try {
        await judgeTokenExp({ dispatch, rootState })
        const { query } = route
        const newQuery = {}
        for (let key in query) {
          if (query[key] && addPurchaseParams[key]) {
            newQuery[addPurchaseParams[key]] = query[key]
          }
        }
        const sendQuery = {
          // curpage: 1,
          courseId: route.params.courseId,
          ...newQuery
        }
        // 课程标准化-获取加价购课程列表
        const {
          data: { result }
        } = await AddPurchase.getCourseList({
          params: { ...sendQuery, curpage: state.page },
          rootState
        })
        if (result.status === 1) {
          const courseList = result.data.courseList
          commit(types.SET_ADDPURCHASE_INFOS, result.data)
          if (!courseList) {
            console.warn('no courseList')
            commit(types.SET_NOMOREDATE, true)
            commit(types.SET_COURSELIST, [])
          }
          if (courseList.length === 0) {
            commit(types.SET_NOMOREDATE, true)
            return
          }
          isLoadMore
            ? commit(types.ADD_COURSE_LIST, courseList)
            : commit(types.SET_COURSELIST, courseList)
          // page页数增加
          commit(types.SET_PAGE, state.page + 1)
          return
        }
        commit(types.SET_COURSELIST, [])
      } catch (e) {
        commit(types.SET_COURSELIST, [])
        const response = e.response
        const status = response && response.status
        if (status === 404) return
        console.log('APIERROR===GET_ADDPURCHASE_COURSE_LIST==', e)
      }
    },
    async [types.GET_ADDPURCHASE_CHECK_COURSE](
      { dispatch, state, commit, rootState },
      { data, route }
    ) {
      // 加价购选课列表
      try {
        await judgeTokenExp({ dispatch, rootState })
        const {
          data: { result }
        } = await AddPurchase.checkCourse(data, { rootState }) // , xesid: rootState.cookies.xesId, devid: 1
        commit(types.SET_ADDPURCHASE_CHECK_COURSE, result.data)
      } catch (e) {
        const response = e.response
        const status = response && response.status
        if (status === 401) {
          await dispatch('GET_TOKEN')
          dispatch(types.GET_ADDPURCHASE_CHECK_COURSE)
          return
        }
        commit(types.SET_ADDPURCHASE_CHECK_COURSE, null)
        if (status === 404) return
        console.log('APIERROR==GET_ADDPURCHASE_CHECK_COURSE===', e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/AddPurchase/store/index.js